import React, { Component } from 'react';
import '../../css/style.css';
import '../Home.css';
import { Row, Col, Pagination, Table, Tooltip, OverlayTrigger, Button } from 'react-bootstrap';
import { translate } from "react-i18next";
import { getURL, sendJson } from '../../backend/Backend';
import PublicEventEditBooking from './PublicEventEditBooking';




class Booked extends Component {

    constructor(props) {
        super(props);
        this.pageChanged = this.pageChanged.bind(this);
        this.searchEvents = this.searchEvents.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onBookingRevert = this.onBookingRevert.bind(this);
        this.onBookingEdit = this.onBookingEdit.bind(this);
      
        this.state = {
            events: [],
            selected : null,
            edit: false,
            activePage: 1,
            totalPages: 0
        };
    }

    onEdit(booking) {
        let oldState = this.state;
        this.setState({
          ...oldState,
          selected: booking,
          edit: !oldState.edit
        });
      }

      onBookingRevert() {
        this.searchEvents(this.state.activePage);
      }

      onBookingEdit(booking) {
        console.log("onBookingEdit called "+JSON.stringify(booking));
        sendJson('put', 'booking', booking).then(
          received => {
            this.searchEvents(this.state.activePage);
          });
      }

    async pageChanged(e) {
        this.searchEvents(e.target.text);
    }

    async searchEvents(page) {
        if (!page) {
            return;
        }
        if ("<" === page) {
            page = --this.state.activePage;
        }
        if (">" === page) {
            page = ++this.state.activePage;
        }

        const response = await fetch(getURL(`booking/${this.props.eventId}/${page - 1}`));
        //const response = await fetch(getURL(`${this.props.preURL}/${this.props.id}/${page - 1}`));
        const json = await response.json();
        let oldState = this.state;
        this.setState({
            ...oldState,
            events: json.content,
            totalPages: json.totalPages,
            activePage: page,
            selected: null,
            edit: false
        });

    }

    async componentDidMount() {
        this.searchEvents(1);

    }


    render() {
        const { t } = this.props;
      
        return (
            <div >
                <Row>
                    <Col className="text-primary mt-1 mb-2"><h4>{this.props.title}</h4></Col>
                </Row>
                <Table striped bordered hover responsive size="sm">
                    <thead>
                        <tr>
                            <th>{t("nr")}</th>
                            <th>{t("fullname")}</th>
                            <th>{t("telNr")}</th>
                            <th>{t("adultCountShort")}</th>
                            <th>{t("childCountShort")}</th>
                            <th>{t("bookingStatus")}</th>
                            <th>{t("edit")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.events.map((e) =>
                              ( this.state.selected && this.state.selected.id === e.id) ? 
                                <tr>
                                <td colSpan="6"><PublicEventEditBooking selected= {e} 
                                 onBookingRevert={this.onBookingRevert}
                                 onBookingEdit={this.onBookingEdit} /></td>
                            </tr>
                            :
                            <tr>
                                <td>{e.id}</td>
                                <td>{e.fullname}</td>
                                <td>{e.telNr}</td>
                                <td>{e.adultCount}</td>
                                <td>{e.childCount}</td>
                                <td>{t(e.bookingStatus)}</td>
                                <td>
                                <OverlayTrigger key="top" placement="top"
                        overlay={
                          <Tooltip id={`tooltip-top`}>
                            {t("bearbeiten")}
                          </Tooltip>
                        }>
                        <Button variant="link" onClick={() => this.onEdit(e)} size="sm" ><span className="fa fa-edit"></span></Button>
                      </OverlayTrigger>
                                </td>
                            </tr>
                             
                            

                        )}
                    </tbody>
                </Table>
                <Row className="mt-2">
                    <Pagination onClick={this.pageChanged}>
                        {this.state.activePage > 1 ?
                            <Pagination.Item>{'<'}</Pagination.Item>
                            : ""
                        }

                        {[...Array(this.state.totalPages).keys()].map(i => {
                            return <Pagination.Item active={(i + 1) === this.state.activePage} key={i} >{i + 1}</Pagination.Item>
                        })
                        }
                        {this.state.activePage < this.state.totalPages ?
                            <Pagination.Item>{'>'}</Pagination.Item>
                            : ""
                        }
                    </Pagination>

                </Row>
            </div>
        );
    }

}

export default translate("translations")(Booked);